import { v1 } from 'uuid';

export enum ModuleTokens {
  Name = 'clouddns-websockets'
}

export const CLOUDDNS_RECEIVER_ID = v1();
